import React from 'react';

export default function AdminAccountPriviliges(props) {
    return <>
        <div className="inner-wrapper min-height" style={{ minHeight: 350 }}>
            <h3>Account Privileges</h3>
            {
                props.priviledges.map((x, i) =>
                    <div className={x.acl_permission.parent_id ? 'text-blk child' : 'text-blk'} key={i}>
                        <span className="label">
                            {x.acl_permission.name}
                        </span>
                    </div>
                )
            }
        </div>
    </>
}